import { get } from 'lodash-es';
import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';

const POCError = {
  isModal: true,
  title: 'No account found',
  buttonTitle: 'Try again',
  description: "There's no Sunbit Account with the info you provided.",
};

const DefaultError = {
  isModal: true,
  title: 'Default Error',
  buttonTitle: 'Try again',
  description: "There's no Sunbit Account with the info you provided.",
};

export default function errorReducer(state: any, action: any): any {
  if (action.status !== ActionStatus.Failure) {
    return { ...state, show: false, code: null };
  }

  const serverErrorCode = get(action, 'errorPayload.code', null);
  if (serverErrorCode) {
    return { ...state, ...action, isOpen: true, ...POCError, show: true, code: serverErrorCode };
  } else {
    return { ...state, ...action, isOpen: true, ...DefaultError, show: true };
  }
}
